import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../../ds';
import { ReactComponent as CheckIcon } from './assets/check-icon.svg';
import { ReactComponent as FileIcon } from './assets/file-icon.svg';
import './bulkTemplateSummary.scss';

const BulkTemplateSummary = ({ fileName = '', onContinue = () => null }) => (
  <>
    <div className='k-ds-heading-05'>Adjuntar plantilla</div>
    <div className='k-ds-m-top-sp-05 bulk-template-summary'>
      <div className='k-ds-body-02'>Adjuntaste la plantilla correctamente</div>
      <div className='bulk-template-summary-card'>
        <div className='bulk-template-summary-name'>
          <FileIcon className='k-ds-m-right-sp-02' />
          <span className='truncate'>{fileName}</span>
        </div>
        <CheckIcon />
      </div>
      <div className='bulk-template-summary-action'>
        <Button
          size='large'
          className='bulk-template-summary-button'
          onClick={onContinue}
        >
          Continuar
        </Button>
      </div>
    </div>
  </>
);

BulkTemplateSummary.propTypes = {
  fileName: PropTypes.string,
  onContinue: PropTypes.func,
};

export default BulkTemplateSummary;
